<footer>
  <div>NooS Global SAS Ⓒ 2023</div>
</footer>
